<template>
    <b-modal
    id="disable-auth-modal"
    :visible="value"
    @change="updateValue"
    @hide="closeModal"
    hide-footer
    centered
    size="md"
    >
    <h5 class="mb-3 text-center">{{ modalData.title }}</h5>
    <label class="text-center">
        {{ modalData.description }}
    </label>
    <input 
      v-model="codeInput" 
      autocapitalize="off" 
      class="swal2-input"
      :placeholder="inputPlaceholder" 
      :type="inputType" 
      @input="updateCodeInput" />

    <div class="d-flex justify-content-center">
        <RecaptchaV2 ref="recaptcha" @verify="setRecaptchaToken" @expired="tokenRecaptcha = ''" />
    </div>

    <div class="swal2-actions">
        <button type="button" class="swal2-confirm swal2-styled btn" @click="disableAuth" :disabled="!tokenRecaptcha">
        {{ modalData.type === 'tokenBackup' ? $ml.get("toCheck") : $ml.get("remove") }}
        </button>
        <button type="button" class="swal2-cancel swal2-styled" @click="closeModal">
        {{ $ml.get("cancel") }}
        </button>
    </div>
    </b-modal>
  </template>
  
  <script>
  import RecaptchaV2 from '../../components/recaptchaV2.vue';
  
  export default {
    components: {
      RecaptchaV2,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      modalData: {
        type: Object,
        required: true
      }
    },
    data() {
        return {
            codeInput: '',
            tokenRecaptcha: "",
        }
    },
    watch: {
      value(newVal) {
        if (newVal) {
          this.codeInput = '';
        }
      },
    },
    methods: {
      closeModal() {
        this.$emit('input', false);
        this.tokenRecaptcha = "";
      },
      updateValue(val) {
        this.$emit('input', val);
      },
      setRecaptchaToken(token) {
        this.$emit('update:setRecaptchaToken', token)
        this.tokenRecaptcha = token;
      },
      updateCodeInput() {
        this.$emit('update:codeInput', this.codeInput)
      },
      disableAuth() {
        this.$emit('disableAuth', this.modalData.type)
      }
    },
    computed: {
      inputPlaceholder() { return this.modalData.type === 'phone' ? 'Digite a senha' : 'Digite o código'},
      inputType() { return this.modalData.type === 'phone' ? 'password' : 'text' }
    },
  };
  </script>
  
  <style>
  .modal-header {
    border-bottom: none !important;
  }
  
  .modal-content {
    border: none !important;
    border-radius: 5px !important;
  }
  </style>
  